import { Component, OnInit, Inject, HostListener, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { Customer } from '../../../models/customers/Customer';
import { AuthService } from '../../../services/auth.service';
import { ToolsService } from '../../../services/tools.service';
export interface DialogData {
    firstname: string;
    lastname: string;
    email: string;
    salutation: string;
    password: string;
    partnerid: string;
    modeLogin: boolean;
    captcha: string;
    domainname: string;
}

@Component({
    selector: 'app-partnerlogin',
    templateUrl: './partnerlogin.component.html',
    styleUrls: ['./partnerlogin.component.scss'],
    standalone: false
})
export class PartnerloginComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    login: FormGroup;
    signup: FormGroup;
    confCode: FormGroup;
    hide: boolean = true;
    modeLogin: number = 0;
    asPartner: boolean = true;
    loading: boolean = false;
    error: string = '';
    sitekey: string = '';
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private fb: FormBuilder,
        private authService: AuthService,
        // private recaptchaV3Service: ReCaptchaV3Service,
        private toolService: ToolsService,
        private dialogRef: MatDialogRef<PartnerloginComponent>
    ) { }

    ngOnInit(): void {
        this.sitekey = this.toolService.getcaptchasitekey();
        this.confCode = this.fb.group({
            confirmation_code: new FormControl(null, [Validators.required, Validators.minLength(6)]),
            floatLabel: 'auto',
        });
        this.login = this.fb.group({
            email: new FormControl(null, [Validators.required, Validators.email]),
            password: new FormControl(null, [Validators.required, Validators.minLength(4)]),
            floatLabel: 'auto',
        });
        this.signup = this.fb.group({
            captcha: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            salutation: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            firstname: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            lastname: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            password: new FormControl(null, [Validators.required, Validators.minLength(8)]),
            floatLabel: 'auto',
        });
    }

    @HostListener('window:beforeunload', ['$event'])
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async onNoClick() {
        this.dialogRef.close();
    }

    async changeMode(val) {
        this.modeLogin = val;
        // this.data.modeLogin = this.modeLogin;
    }

    async loginF() {
        if (!this.login.invalid) {
            this.error = '';
            let suffix = 'login';
            if (this.asPartner) {
                suffix = 'loginaspartner';
            }
            const target = {
                email: this.login.value.email,
                password: this.login.value.password,
                partnerid: this.data.partnerid
            }
            this.authService.request(target, suffix).pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res: Customer) => {
                if (res.error) {
                    this.error = res.error;
                } else {
                    res.asPartner = this.asPartner;
                    this.authService._setSession(res);
                    this.authService.setAuth(res);
                    this.dialogRef.close(res);
                }
            });
        } else {
            this.login.markAllAsTouched();
        }
    }

    async detectEnter() {
        this.loginF();
    }

    // async registrierenF() {
    //     this.loading = true;
    //     this.recaptchaV3Service.execute('signupfunction').pipe(
    //         takeUntil(this.unsubscribe$)
    //     ).subscribe((token) => this.signupF(token));
    // }

    // async signupF(token) {
    //     this.signup.get('captcha').setValue(token);
    //     if (!this.signup.invalid && this.signup.value.password === this.signup.value.conf_password) {
    //         this.error = '';
    //         const target = {
    //             email: this.signup.value.email,
    //             password: this.signup.value.password,
    //             firstname: this.signup.value.firstname,
    //             lastname: this.signup.value.lastname,
    //             salutation: this.signup.value.salutation,
    //             partnerid: this.data.partnerid,
    //             token: token,
    //         }
    //         this.authService.request(target, 'signup').pipe(
    //             takeUntil(this.unsubscribe$)
    //         ).subscribe((res: Customer) => {
    //             if (res.error) {
    //                 this.error = res.error;
    //             } else {
    //                 // this.authService._setSession(res);
    //                 // this.dialogRef.close(res);

    //                 this.data.email = this.signup.value.email;
    //                 this.data.firstname = this.signup.value.firstname;
    //                 this.data.lastname = this.signup.value.lastname;
    //                 this.data.salutation = this.signup.value.salutation;

    //                 this.modeLogin = 2;
    //             }
    //             this.loading = false;
    //         });
    //     } else {
    //         this.signup.get('conf_password').setValue('');
    //         this.signup.markAllAsTouched();
    //     }
    // }

    async chackconfirmationcode() {
        this.loading = true;
        if (this.confCode.value.confirmation_code?.length > 0) {
            this.error = '';
            const target = {
                partnerid: this.data.partnerid,
                email: this.data.email,
                confirmation_code: this.confCode.value.confirmation_code,
            }
            this.authService.request(target, 'chackconfirmationcode').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res: Customer) => {
                if (res?.error) {
                    this.confCode.get('confirmation_code').setValue('');
                    this.confCode.markAllAsTouched();
                } else {
                    this.authService._setSession(res);
                    this.dialogRef.close(res);
                }
                this.loading = false;
            });
        } else {
            this.confCode.markAllAsTouched();
        }
    }

    async goto(link) {
        window && window.open(this.data.partnerid + '/' + link, '_blank')
    }
}
